import { TFunction } from "i18next";
import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DIGIPOSTHEME } from "theme/digiPosTheme";

import EmployeeEditModal from "./EmployeeEditModal";
import Image, { ICONS } from "components/BaseComponents/Image";
import Typography from "components/BaseComponents/Typography";
import {
  StyledEmpDetailCircleWrapper,
  StyledEmpDetailIconCircle,
} from "../EmployeePanel/EmployeeDetail.styles";
import { StyledEmpPanelActionButton } from "../EmployeePanel/EmployeePanel.styles";
import { useAppSelector } from "redux/hooks";
import { FindAgent } from "helpers/FindAgent";

interface AgentEditProps {
  phoneNumber: string;
  name: string;
  t: TFunction;
  isDetail: boolean;
}

const AgentEdit: FC<AgentEditProps> = ({ phoneNumber, name, t, isDetail }) => {
  const navigate = useNavigate();

  const { agents } = useAppSelector((state) => state.employeeManagement);

  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false);
  const EmpEdit = (name: string, phoneNumber: string) => {
    const singleAgent = FindAgent(agents?.AgentList!, phoneNumber!);
    if (singleAgent?.Status === "2") setIsEditModalOpen((prev) => !prev);
    else navigate(`/edit-agent/${name}/${phoneNumber}`);
  };

  useEffect(() => {
    return () => {
      phoneNumber = "";
      name = "";
    };
  }, [phoneNumber, name]);

  return (
    <>
      {!isDetail ? (
        <>
          <StyledEmpPanelActionButton
            bgColor={DIGIPOSTHEME.colors.transparent}
            onClick={() => EmpEdit(name!, phoneNumber!)}
          >
            <Image
              borderRadius='5px'
              backgroundColor={DIGIPOSTHEME.colors.transparent}
              alt='Menu Icon'
              height='35px'
              srcSet={ICONS.EDIT}
              width='35px'
              margin='0 5px'
              tooltipInfo={t("agent_edit").toString()}
            />
          </StyledEmpPanelActionButton>
          {isEditModalOpen && (
            <EmployeeEditModal
              acceptButtonText={t("yes").toString()}
              message={t("agent_cancel_edit_for_inactive_message").toString()}
              rejectButtonText={t("no").toString()}
              setIsOpen={setIsEditModalOpen}
              title={t("information").toString()}
              phoneNumber={phoneNumber!}
              name={name!}
              isSim={false}
            />
          )}
        </>
      ) : (
        <>
          <StyledEmpDetailCircleWrapper>
            <StyledEmpDetailIconCircle>
              <Image
                alt='Menu Icon'
                height='30px'
                srcSet={ICONS.EDIT}
                width='30px'
                onClick={() => EmpEdit(name!, phoneNumber!)}
              />
            </StyledEmpDetailIconCircle>
            <Typography width='' size='14px'>
              {t("agent_edit")}
            </Typography>
          </StyledEmpDetailCircleWrapper>
          {isEditModalOpen && (
            <EmployeeEditModal
              acceptButtonText={t("yes").toString()}
              message={t("agent_cancel_edit_for_inactive_message").toString()}
              rejectButtonText={t("no").toString()}
              setIsOpen={setIsEditModalOpen}
              title={t("information").toString()}
              phoneNumber={phoneNumber!}
              name={name!}
              isSim={false}
            />
          )}
        </>
      )}
    </>
  );
};

export default AgentEdit;
